import { render, staticRenderFns } from "./UserBalanceBalancesChart.vue?vue&type=template&id=2ad21498&scoped=true&"
import script from "./UserBalanceBalancesChart.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalancesChart.vue?vue&type=script&lang=js&"
import style0 from "./UserBalanceBalancesChart.vue?vue&type=style&index=0&id=2ad21498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad21498",
  null
  
)

export default component.exports